import * as Yup from 'yup';
import i18next from 'i18next';
import { prop } from 'ramda';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { AdminProfileForm } from './adminProfileFormComponent';

import { updateActiveUser } from '../../../../modules/auth/authActions';

import { withForm } from '../../../../utils/enhancers';

export const AdminProfileFormContainer = compose(
  connect(({ auth }) => ({ admin: auth.activeUser }), { updateActiveUser }),
  withForm({
    mapPropsToValues: ({ admin }) => ({ email: prop('email', admin), name: prop('name', admin) }),
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email(i18next.t('forms.common.emailForm.errors.isNotValid'))
        .required(i18next.t('forms.common.emailForm.errors.required')),
      name: Yup.string()
        .required(i18next.t('forms.common.name.errors.required')),
    }),
    handleSubmit: (values, { setSubmitting, props: { updateActiveUser } }) => {
      setSubmitting(true);

      updateActiveUser(values);
    },
  }),
)(AdminProfileForm);
